module.exports = __webpack_public_path__ + "954044223d8f0f7ae5f1c694d5002bdf.ttf";